import { Injectable } from '@angular/core';

import { LearningAppsState } from '@app/modules/learning-apps/states/learning-apps-state';

@Injectable({ providedIn: 'root' })
export class LearningAppsFacade {
  /** Observable stream for learning grid apps data */
  public learningAppsGrid$ = this.state.learningAppsGridData$;
  /** Observable stream for learning apps data */
  public learningApps$ = this.state.learningApps$;
  public isLoading$ = this.state.isLoading$;
  /** Course Column Keys */
  public readonly courseColumnKeys = this.state.courseColumnKeys;
  /** Course Column Names */
  public readonly courseColumnNames = this.state.courseColumnNames;
  public gridState$ = this.state.gridState$;
  public paginationConfig$ = this.state.paginationConfig$;
  public onDataSortChange = this.state.onDataSortChange.bind(this.state);
  public onPageChange = this.state.onPageChange.bind(this.state);

  constructor(private readonly state: LearningAppsState) {}
}
